import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Paragraph from '@mos-cat/paragraph';
import { Heading } from '@mos-cat/typography';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MosSelect from '@mos-front-components/public/es/components/MosSelect';
import TextArea from '@mos-cat/text-area';

import Table from '../../components/Table/Table';
import Button from '../../components/Button/Button';
import ExamInformation from '../../components/ExamInformation/ExamInformation';
import { pluralizeNumber } from './helper';

import {
  changeExam,
  approveExam,
  updateAppealData,
  toggleExamShowOnlyIncorrect
} from '../../store/examData/actions';
import { setNotCorrectExam } from '../../store/notCorrectExam/actions';
import { saveDraft } from '../../store/draft/actions';
import {
  answerPropTypes,
  answerDefaultProp
} from '../../propTypes/answerPropTypes';
import structuredSelector from './structuredSelector';

import './Correction.pcss';
import { gradesTableType } from '../../propTypes/gradesTableType';
import { EMOJI_REGEXP } from '../../constants/regexp';
import AppealExists from '../../components/AppealExists/AppealExists';

/* eslint-disable no-useless-escape*/

class ExamApprove extends PureComponent {
  render() {
    const {
      examName,
      onExamApprove,
      onExamReject,
      currentExam,
      blockedByAppealSearch,
      saveDraft
    } = this.props;
    return (
      <>
        {examName && !blockedByAppealSearch && !currentExam.examApprove && (
          <div className="Correction__Block">
            <div className="Correction__Approve">
              <div className="Correction__ApproveTitle">
                Подтвердите, что это ваша работа, предварительно ознакомившись с
                экзаменационными материалами для&nbsp;просмотра (прослушивания)
              </div>
              <div className="Correction__ApproveDocs">
                <a className="Correction__DocButton" href={currentExam.file}>
                  Материалы для просмотра (прослушивания)
                </a>
              </div>
              <div>
                <Paragraph className="Correction__InfoListLabel">
                  Проверьте, что в представленных материалах:
                </Paragraph>
                <ul className="Correction__InfoList">
                  <li>присутствуют все листы вашей экзаменационной работы</li>
                  <li>отсутствуют листы чужой экзаменационной работы</li>
                  <li>в аудиоматериалах (при наличии) звучит ваш голос</li>
                </ul>
              </div>
              <Heading level={4} style={{ marginTop: '32px' }}>
                Вы подтверждаете, что представленные материалы соответствуют
                вашей экзаменационной работе?
              </Heading>
              <div className="Correction__ApproveButtons">
                <Button
                  onClick={() => {
                    onExamApprove(examName);
                    saveDraft();
                  }}
                >
                  Да, подтверждаю
                </Button>
                <Button
                  onClick={() => {
                    onExamReject(examName);
                    saveDraft();
                  }}
                >
                  Нет, не подтверждаю
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

class Correction extends PureComponent {
  render() {
    const {
      onExamChange,
      onExamApprove,
      onExamReject,
      onUpdateAppealData,
      onToggleShowOnlyIncorrect,

      show,
      showOnlyIncorrectByGrade,
      examsListAvailable,
      checkedGrades,
      currentExam,
      blockedByAppealSearch,
      saveDraft
    } = this.props;

    if (!show) {
      return null;
    }

    const examName = currentExam.subject_name || '';
    const gveField = currentExam.grades_table
      ? currentExam.grades_table.find(
          item => item && item.task_number === 'c_1'
        ) || { invalid: true, comment: '' }
      : { invalid: true, comment: '' };
    const selectSuggestions = examsListAvailable.map(exam => ({
      text: exam.subject_name,
      value: exam.examId
    }));
    const selectValueObject = selectSuggestions.find(
      examItem => examItem.value === currentExam.examId
    );

    return (
      <div className="Correction">
        <div className="Correction__Block">
          <Paragraph style={{ marginBottom: '12px' }}>
            Выберите предмет, по которому вы хотите подавать апелляцию
          </Paragraph>
          <Paragraph>
            Отображаются только те предметы, по которым доступна подача
            апелляции
          </Paragraph>
          <div className="Correction__ExamName">
            <MosSelect
              dropListView
              placeholder="Экзамен, по которому вы хотите подать апелляцию"
              value={selectValueObject ? selectValueObject.text : ''}
              suggestions={selectSuggestions}
              onChange={({ text, value }) => {
                onExamChange({ examName: text, examId: value });
                saveDraft();
              }}
            />
          </div>

          {!!examName && (
            <>
              <Heading level={2} style={{ marginBottom: '0px' }}>
                {examName}&nbsp;— {currentExam.score}{' '}
                {pluralizeNumber(currentExam.score)}
              </Heading>

              <ExamInformation exam={currentExam} />

              <Paragraph style={{ margin: '12px 0' }}>
                Подача апелляции возможна в период с{' '}
                <span className="Correction__textBold">
                  {currentExam.appeal_start_date_formatted} 00:00
                </span>{' '}
                до{' '}
                <span className="Correction__textBold">
                  {currentExam.appeal_end_date_formatted} 23:59
                </span>
                {!!currentExam.appeal_start_date2_formatted && (
                  <span className="Correction__ExamDateAdditional">
                    {' '}
                    и с&nbsp;
                    <span className="Correction__textBold">
                      {currentExam.appeal_start_date2_formatted} 00:00
                    </span>{' '}
                    до{' '}
                    <span className="Correction__textBold">
                      {currentExam.appeal_end_date2_formatted} 23:59
                    </span>
                  </span>
                )}
              </Paragraph>

              <div className="Correction__ExamInfoAdditional">
                Протокол ГЭК №{currentExam.protocol_number} от{' '}
                {currentExam.protocol_date_formatted}
              </div>
            </>
          )}
        </div>

        {examName && <AppealExists />}

        <ExamApprove
          currentExam={currentExam}
          examName={examName}
          onExamApprove={onExamApprove}
          onExamReject={onExamReject}
          blockedByAppealSearch={blockedByAppealSearch}
          saveDraft={saveDraft}
        />

        {currentExam.examApprove && !blockedByAppealSearch && (
          <div className="Correction__Approved">
            <div className="Correction__ExamInfoButtons">
              <a className="Correction__DocButton" href={currentExam.file}>
                Материалы для просмотра (прослушивания)
              </a>
            </div>

            {currentExam.type_is_gve ? (
              <>
                <Paragraph className="Correction__comment Correction__comment__gve">
                  Добавьте комментарий, если вы не согласны с выставленной
                  оценкой. В поле «Комментарий» может быть внесено не более 1000
                  символов.
                </Paragraph>

                <TextArea
                  rows={2}
                  className="Correction__gve__textField"
                  label="Ваш комментарий"
                  onChange={ev => {
                    onUpdateAppealData({
                      comment: ev.currentTarget.value.replace(EMOJI_REGEXP, ''),
                      checked: true,
                      changedTask: {
                        task_number: 'c_1',
                        task_name: examName,
                        test_score: currentExam.score,
                        detailed: false,
                        primary_score: '5'
                      }
                    });
                    saveDraft();
                  }}
                  value={gveField.comment}
                  error={gveField.invalid}
                  maxLength={1000}
                />
              </>
            ) : (
              <>
                <Heading level={2} style={{ marginBottom: '0px' }}>
                  Результаты выполнения экзаменационной работы
                </Heading>
                <Paragraph className="Correction__comment">
                  Отметьте задания, с оцениванием которых вы не согласны, и
                  укажите комментарий. В поле «Комментарий» к каждому заданию
                  может быть внесено не более 1000 символов.
                </Paragraph>

                <Paragraph className="Correction__comment">
                  <span className="Correction__highlighted Correction__highlighted-red">
                    <span>Задания, по которым получено 0&nbsp;баллов</span>
                  </span>
                  <span className="Correction__highlighted Correction__highlighted-orange">
                    <span>
                      Задания, по которым получено не&nbsp;максимальное
                      количество баллов
                    </span>
                  </span>
                </Paragraph>

                <div className="Correction__table-wrapper">
                  <div className="Correction__tables">
                    {currentExam.grades_table_raw.map((table, i) => {
                      const tableIndex = i + 1;
                      return (
                        <Table
                          key={i}
                          data={checkedGrades}
                          saveDraft={saveDraft}
                          showOnlyIncorrect={
                            showOnlyIncorrectByGrade[tableIndex]
                          }
                          onUpdateAppealData={onUpdateAppealData}
                          onToggleShowOnlyIncorrect={onToggleShowOnlyIncorrect}
                          htmlTable={table}
                          className="Correction__table Correction__table_answerShort"
                          indexOfTable={tableIndex}
                        />
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

Correction.defaultProps = {
  examsListAvailable: [],
  checkedGrades: [],
  currentExam: {
    subject_name: '',
    score: '',
    date: '',
    protocol_date: '',
    file: '',
    prescore: '',
    minscore: '',
    maxscore: '',
    type: '',
    examApprove: false
  },
  answerDefault: answerDefaultProp,
  answerShort: answerDefaultProp,
  answerDetailed: answerDefaultProp,
  answerSpeakingPart: answerDefaultProp,
  answerSpeakingCriterias: answerDefaultProp,

  blockedByAppealSearch: false
};

Correction.propTypes = {
  show: PropTypes.bool.isRequired,
  examsListAvailable: PropTypes.arrayOf(PropTypes.shape({})),
  checkedGrades: gradesTableType.isRequired,
  currentExam: PropTypes.shape({
    subject_name: PropTypes.string,
    score: PropTypes.string,
    date: PropTypes.string,
    protocol_date: PropTypes.string,
    file: PropTypes.string,
    prescore: PropTypes.string,
    minscore: PropTypes.string,
    maxscore: PropTypes.string,
    type: PropTypes.string,
    examApprove: PropTypes.bool
  }),
  showOnlyIncorrectByGrade: PropTypes.shape({}),
  /* eslint-disable react/no-unused-prop-types */
  answerDefault: answerPropTypes,
  answerShort: answerPropTypes,
  answerDetailed: answerPropTypes,
  answerSpeakingPart: answerPropTypes,
  answerSpeakingCriterias: answerPropTypes,
  blockedByAppealSearch: PropTypes.bool,

  onExamApprove: PropTypes.func.isRequired,
  onExamReject: PropTypes.func.isRequired,
  onExamChange: PropTypes.func.isRequired,
  onUpdateAppealData: PropTypes.func.isRequired,
  onUpdateShowOnlyIncorrect: PropTypes.func.isRequired
};

export default connect(structuredSelector, dispatch =>
  bindActionCreators(
    {
      onExamChange: changeExam,
      onExamApprove: approveExam,
      onExamReject: setNotCorrectExam,
      onUpdateAppealData: updateAppealData,
      onToggleShowOnlyIncorrect: toggleExamShowOnlyIncorrect,
      saveDraft
    },
    dispatch
  )
)(Correction);
